import { getAxiosClient } from "../../axios-client";
import { UpdateOfferRequestBody, UpdateOfferResponse } from "./types";

const axiosClient = getAxiosClient();
export const offerUpdate = async (body: UpdateOfferRequestBody) => {
  return await axiosClient.ax.put<UpdateOfferResponse>(
    "/Offers/UpdateOffer",
    body
  );
};
